import React from "react";
import { Box } from "@chakra-ui/react";
import { AgendaContainer } from "@components";

const AgendaSection = ({ onActiveTabChange }) => {
  return <AgendaContainer onActiveTabChange={onActiveTabChange} />;
};

export default AgendaSection;
